export default __webpack_public_path__ + "static/L_Bound_Angle_Pose_SIMPLIFIED-23bdfbd55e20c24dc8f7aab13ec9d416.svg";